module.exports = __webpack_public_path__ + "static/media/development_design.eb9f3795.PNG";